import { createAsyncThunk } from '@reduxjs/toolkit'
import { policiesData } from '@assets/mockdata'
import { Policy, UpdatePolicyThunkParams } from '@dataTypes/index'

export const fetchAllPolicies = createAsyncThunk(
  'policies/fetchAllPolicies',
  async () => {
    return policiesData
  },
)

export const addPolicy = createAsyncThunk(
  'policies/addPolicy',
  async (body: Policy) => {
    return body
  },
)

export const updatePolicy = createAsyncThunk(
  'policies/updatePolicy',
  async (params: UpdatePolicyThunkParams) => {
    const { id, body } = params
    return { id, body }
  },
)

export const removePolicy = createAsyncThunk(
  'policies/removePolicy',
  async (index: string) => {
    return index
  },
)
